import { clsx } from "clsx"
import { RegularButton } from "@/components/Button/RegularButton/RegularButton.component"
import { Translation } from "@/components/Translation/Translation.component"
import type { Locale } from "@/ts/locale/locale.types"

export const newsletterFailedMessage: Record<Locale, string> = {
  da: "Det lykkedes ikke at tilmelde dig nyhedsbrevet.",
  de: "Bei der Anmeldung zu unserem Newsletter ist ein Fehler aufgetreten.",
  en: "There was an error subscribing to the newsletter.",
  no: "Noe gikk galt under påmeldingen til nyhetsbrevet.",
  sv: "Det gick inte att prenumerera på nyhetsbrevet.",
}

type NewsletterSignUpFailedBoxProps = {
  readonly className?: string
  readonly reset: () => void
  readonly variant?: "accent" | "primary"
}

export function NewsletterSignUpFailedBox({
  className,
  reset,
  variant = "primary",
}: NewsletterSignUpFailedBoxProps) {
  return (
    <div className={clsx("min-h-[300px] space-y-4 md:max-w-md", className)}>
      <p className="leading-snug">
        <Translation model={newsletterFailedMessage} />
      </p>
      <RegularButton
        className="mt-2 w-full md:max-w-sm"
        onClick={reset}
        position="nl-retry-btn"
        testId="newsletter-retry-button"
        variant={variant}
      >
        <Translation
          da="Prøv igen"
          de="Versuchen Sie es bitte erneut"
          en="Try again"
          no="Prøv igjen"
          sv="Försök igen"
        />
      </RegularButton>
    </div>
  )
}
